/* import __COLOCATED_TEMPLATE__ from './mass-start.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class MassStartTimingComponent extends Component
{
	@service ajax;

	@tracked selectedStartImpulse = null;

	@action
	startImpulseClicked(timingRecord)
	{
		this.selectedStartImpulse = timingRecord;
	}

	@action
	async enterStartTimeNow()
	{
		const response = await this.ajax.request("/events/"+this.args.event.id+"/enterStartTime");

		if(response.error != null)
			alert(response.error);
	}
}

